/**
 * Cash/Efectivo policy product helpers (Creditech BNPL).
 * REACT_APP_CASH_POLICY_PRODUCT_ID must match CASH_POLICY_PRODUCT_ID in lenders_backoffice.
 */
export const GEO_LOCATION_VALIDATION_STEP = 'GeoLocationValidationStep';

export const getCashPolicyProductId = () => {
  const raw = process.env.REACT_APP_CASH_POLICY_PRODUCT_ID;
  if (raw === undefined || raw === null || String(raw).trim() === '') {
    return null;
  }

  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : null;
};

export const isCashPolicyProduct = (policyProductId) => {
  const cashId = getCashPolicyProductId();
  if (cashId === null || policyProductId === undefined || policyProductId === null || policyProductId === '') {
    return false;
  }

  return Number(policyProductId) === cashId;
};

export const withoutGeoLocationStepIfCash = (steps, policyProductId) => {
  const list = Array.isArray(steps) ? steps : [];
  if (!isCashPolicyProduct(policyProductId)) {
    return [...list];
  }

  return list.filter((step) => step !== GEO_LOCATION_VALIDATION_STEP);
};
